import { ListPagination } from 'api'
import * as t from 'io-ts'
import { NumberFromString } from 'io-ts-types'

import { decodeHeaders } from './decode-headers'
import { decodeJson } from './decode-json'

export type JsonArrayWithTotal<T> = {
  rows: Array<T>
  total: number
  nextPage?: number
}

const THeaders = t.strict({ total: NumberFromString })

export const decodeJsonWithTotal = <TCodec extends t.Mixed>(
  codec: TCodec,
  pagination: ListPagination,
) => {
  return async (
    response: Response,
  ): Promise<JsonArrayWithTotal<t.TypeOf<TCodec>>> => {
    const headers = decodeHeaders(THeaders)(response)
    const rows = await decodeJson(t.array(codec))(response)

    const total = headers.total

    return {
      rows,
      total,
      nextPage:
        total > pagination.page * pagination.pageSize + rows.length
          ? pagination.page + 1
          : undefined,
    }
  }
}
